import z from '@/lib/zod';
import { optionalSearchString } from '@/lib/zod-search-params';
import { commonSearchSchema } from './commonSearchSchema';

/**
 * Nome nell'URL del filtro Area dei ticket. Non è `category` come nell'API:
 * `category` è già il parametro del Centro assistenza (`/help`, enum degli
 * slug), e TanStack Router fonde i search di tutte le rotte nelle letture
 * `strict: false` — con lo stesso nome il tipo di `category` diventava
 * `string` anche per l'Help.
 */
export const SUPPORT_TICKET_CATEGORY_SEARCH_PARAM = 'ticketCategory';

/**
 * `subTab` è l'unico filtro di stato della lista: lo stato lo decide la tab
 * (`getSupportTicketTabFilters`), non un parametro a parte. Un `status`
 * nell'URL sarebbe una seconda sorgente per lo stesso filtro.
 *
 * `category` resta accettato in ingresso per i link scritti con il nome
 * vecchio e confluisce in `ticketCategory`, che vince se ci sono entrambi;
 * in uscita non esiste più.
 */
export const supportSearchSchema = commonSearchSchema
  .extend({
    subTab: z.string().nullish(),
    // Pannello Filtri (tavola 8a): nomi dell'API, salvo l'Area (vedi sopra).
    // Lo stato NO: è la tab.
    createdFrom: optionalSearchString(),
    createdTo: optionalSearchString(),
    type: optionalSearchString(),
    [SUPPORT_TICKET_CATEGORY_SEARCH_PARAM]: optionalSearchString(),
    priority: optionalSearchString(),
    category: optionalSearchString(),
  })
  .transform(({ category, ...search }) => ({
    ...search,
    ticketCategory: search.ticketCategory ?? category,
  }));
